<template>
  <div class="content_menu clearfix">
    <div class="left" style="width:343px">
      <div class="left" style="width:178px;">
        <TheFoodMenu active="salads" />
      </div>

      <div class="left" style="margin:0px 0 0 33px;">
        <img src="/assets/images/titles/menu_left_salad.png">
      </div>

      <br clear="all" />
    </div>

    <div class="right" style="width:552px; margin:8px 0px 0 0;">
      <div class="left" style="width:522px; height:117px;">
        <img src="/assets/images/menu_img/salads.png">
      </div>

      <br clear="all" />

      <div class="product-container">
        <ProductList :products="products" />

        <br clear="all" />

        <div class="left" style="margin:-10px 0 0 -20px;">
          <img src="/assets/images/menu_img/menu_salad_bottom.png" />
        </div>
      </div>

      <div class="menu_right">
        <div class="right" style="margin:-116px 14px 0 0;">
          <img src="/assets/images/menu_img/menu_salad_side.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheFoodMenu from '@/components/TheFoodMenu.vue';
import ProductList from '@/components/ProductList.vue';

export default {
  name: 'Salads',

  components: {
    TheFoodMenu,
    ProductList,
  },

  data() {
    return {
      products: [
        {
          id: 1,
          name: 'JEFFREY’S SIGNATURE SALAD',
          description: 'Spring mix tossed in our lemon vinaigrette, topped with strawberries, caramelized pecans and blue cheese crumbles on a bed of honeydew and cantaloupe melon. Protein options include steak or chicken breast',
          modifiers: [],
        },
        {
          id: 2,
          name: 'CAESAR SALAD',
          description: 'Romaine hearts tossed in our eggless Caesar dressing sprinkled with parmesan cheese and garlicky bread crumbs. Protein options include steak or chicken breast',
          modifiers: [],
        },
        {
          id: 3,
          name: 'SIDE SALAD',
          description: 'Mixed iceberg and romaine lettuces topped with shredded carrots and cucumbers. Choice of ranch, blue cheese, 1000 island or lemon vinaigrette dressings',
          modifiers: [],
        },
      ],
    };
  },
};
</script>
